module.exports = __webpack_public_path__ + "img/icon_num_jx.6a84459f.png";